// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1R7vq","content":"GlobalSearch_content__1iULJ"};